import React, { useState } from "react";
import Timeline from "./components/Timeline/Timeline";
import AnalysisMap from "./components/AnalysisMap/AnalysisMap";
import Scatterplot from "./components/Scatterplot/Scatterplot";
import Demographics from "./components/Demographics/Demographics";
import filterFunctions from "../../functions/filterFunctions";
import styles from "./Analysis.module.css";
import Neighborhoods from "./components/Neighborhoods/Neighborhoods";
import moment from "moment";
import NeighborhoodTable from "./components/NieghborhoodTable/NeighborhoodTable";
import tz from "moment-timezone";
import GoogleAd from "../../SunTimesUI/GoogleAd/GoogleAd";

const Analysis = ({ homicides }) => {
  console.log(homicides);
  const [timePeriod] = useState("2021");
  // const data = homicides.filter((d) =>
  //   filterFunctions.timePeriod(d, timePeriod, "08/23/2021")
  // );
  const data = homicides;

  // const updatedTime = moment(homicides.feed.updated["$t"])
  //   .tz("America/Chicago")
  //   .format("MMMM Do, YYYY h:mm a");

  return (
    <div className={styles.Analysis}>
      <GoogleAd />
      <p className={styles.WORKINPROGRESS}>THIS IS A WORK IN PROGRESS</p>
      <h1>Chicago Homicide 2021 Analysis</h1>
      <p className={styles.Byline}>
        <span>Graphics by</span> Jesse Howe and Andy Boyle
      </p>
      {/* <span className={styles.Updated}>Updated: {"here"}</span> */}
      <Timeline data={data} timePeriod={timePeriod} />
      <AnalysisMap data={data} />
      <NeighborhoodTable data={homicides} />
      <Scatterplot data={data} />
      <Demographics data={data} />
      <Neighborhoods data={homicides} />
      <GoogleAd />
    </div>
  );
};

export default Analysis;
